import React, { useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Typography,
    Modal
} from '@mui/material';
import './EventHistory.css';

/**
 * EventHistory Component
 * Displays event history table with filtering
 */
const EventHistory = ({ events }) => {
    const [filter, setFilter] = useState('ANPR');
    const [selectedImage, setSelectedImage] = useState(null);

    // Filter events
    const filteredEvents = events.filter(event => {
        if (filter === 'all') return true;
        const eventType = (event.event_type || event.type || '').toLowerCase();
        if (filter === 'ANPR' && eventType === 'plates') return true;
        return eventType === filter.toLowerCase();
    });

    // Format event type
    const formatEventType = (eventType) => {
        if (!eventType) return '-';
        if (eventType.toLowerCase() === 'heartbeat' || eventType === 'heartBeat') {
            return '💓 Heartbeat';
        }
        if (eventType === 'ANPR' || eventType === 'PLATES') return '🚗 ANPR';
        return eventType.charAt(0).toUpperCase() + eventType.slice(1).toLowerCase();
    };

    // Format direction
    const formatDirection = (direction) => {
        if (!direction || direction === '-') return '-';
        return direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();
    };

    // Handle image click
    const handleImageClick = (imagePath) => {
        setSelectedImage(`${process.env.REACT_APP_API_URL}/${imagePath}`);
    };

    return (
        <Box>
            {/* Filter Buttons */}
            <Box className="filter-buttons" sx={{ mb: 2 }}>
                <Button
                    variant={filter === 'all' ? 'contained' : 'outlined'}
                    onClick={() => setFilter('all')}
                    className="filter-btn"
                >
                    Svi
                </Button>
                <Button
                    variant={filter === 'ANPR' ? 'contained' : 'outlined'}
                    onClick={() => setFilter('ANPR')}
                    className="filter-btn"
                >
                    ANPR
                </Button>
                <Button
                    variant={filter === 'heartbeat' ? 'contained' : 'outlined'}
                    onClick={() => setFilter('heartbeat')}
                    className="filter-btn"
                >
                    Heartbeat
                </Button>
            </Box>

            {/* Events Table */}
            <TableContainer component={Paper} className="table-container">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Vreme</TableCell>
                            <TableCell>Tip</TableCell>
                            <TableCell>Tablica</TableCell>
                            <TableCell>Kamera</TableCell>
                            <TableCell>Pravac</TableCell>
                            <TableCell>Pouzdanost</TableCell>
                            <TableCell>Vozilo</TableCell>
                            <TableCell>Brzina</TableCell>
                            <TableCell>IP</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredEvents.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={9} align="center" className="no-data">
                                    Nema podataka
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredEvents.map((event, index) => {
                                const hasImage = event.image_path || event.image;
                                const imagePath = event.image_path || event.image;
                                const plateText = event.plate || event.license_plate || '-';

                                return (
                                    <TableRow
                                        key={event.id || index}
                                        className={index === 0 ? 'new-event' : ''}
                                    >
                                        <TableCell>
                                            {event.server_time || event.timestamp || event.created_at || '-'}
                                        </TableCell>
                                        <TableCell>{formatEventType(event.event_type || event.type)}</TableCell>
                                        <TableCell>
                                            {hasImage ? (
                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        color: '#4CAF50',
                                                        textDecoration: 'underline',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleImageClick(imagePath)}
                                                >
                                                    {plateText}
                                                </Typography>
                                            ) : (
                                                plateText
                                            )}
                                        </TableCell>
                                        <TableCell>{event.camera_id || '-'}</TableCell>
                                        <TableCell>{formatDirection(event.direction)}</TableCell>
                                        <TableCell>
                                            {event.confidence || event.confidence_level || '-'}
                                            {event.confidence ? '%' : ''}
                                        </TableCell>
                                        <TableCell>{event.vehicle?.type || event.vehicle_type || '-'}</TableCell>
                                        <TableCell>
                                            {event.vehicle?.speed || event.vehicle_speed || '-'}
                                            {event.vehicle?.speed ? ' km/h' : ''}
                                        </TableCell>
                                        <TableCell>{event.ip || event.ip_address || '-'}</TableCell>
                                    </TableRow>
                                );
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Image Modal */}
            <Modal
                open={!!selectedImage}
                onClose={() => setSelectedImage(null)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box
                    sx={{
                        outline: 'none',
                        cursor: 'pointer'
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Event"
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            borderRadius: '8px',
                            boxShadow: '0 0 50px rgba(0, 0, 0, 0.5)'
                        }}
                    />
                </Box>
            </Modal>
        </Box>
    );
};

export default EventHistory;
